// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"photos-module--imgContainer--1z1RW","image":"photos-module--image--RzcCJ","desktopImage":"photos-module--desktopImage--1UGT6"};